/* Copy da config de moderação (kill-switch do fastpath + política do scanner). As mensagens
   específicas de código de erro do config-service (`configServiceErrorMessage`, em `lib/`) ficam
   fora do escopo desta migração — só o fallback genérico passado a ela é traduzido aqui. */
import type { Bilingual } from '../bilingual.js';
import { useBilingual } from '../locale-provider.js';

interface ModerationConfigContent {
  readonly pageTitle: string;
  readonly pageDescription: string;
  readonly infoAlert: string;
  readonly loadError: string;
  readonly saveSuccess: string;
  readonly saveErrorFallback: string;
}

const MODERATION_CONFIG_CONTENT: Bilingual<ModerationConfigContent> = {
  'pt-BR': {
    pageTitle: 'Config de moderação',
    pageDescription:
      'Kill-switch do fastpath e política do scanner que valem para toda a moderação.',
    infoAlert:
      'Estes controles vêm do config-service (valor efetivo, live). O kill-switch do fastpath e ' +
      'a política do scanner valem para toda a moderação — mudanças ficam na trilha de auditoria.',
    loadError: 'Falha ao carregar a config de moderação.',
    saveSuccess: 'Config de moderação salva.',
    saveErrorFallback: 'Falha ao salvar a config de moderação.',
  },
  'en-US': {
    pageTitle: 'Moderation config',
    pageDescription: 'Fastpath kill-switch and scanner policy that apply to all moderation.',
    infoAlert:
      'These controls come from the config-service (live effective value). The fastpath ' +
      'kill-switch and scanner policy apply to all moderation — changes go into the audit trail.',
    loadError: 'Failed to load the moderation config.',
    saveSuccess: 'Moderation config saved.',
    saveErrorFallback: 'Failed to save the moderation config.',
  },
};

export const useModerationConfigContent = (): ModerationConfigContent =>
  useBilingual(MODERATION_CONFIG_CONTENT);
